/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { useTranslation } from "react-i18next";
import 'ag-grid-community/dist/styles/ag-grid.css';
import '../../assets/styles/inner/table.scss';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import VerticalDivider from '../../assets/icons/svg/vertical-divider.svg';
import SearchVector from '../../assets/icons/svg/search-vector.svg';
import CloseSearch from '../../assets/icons/svg/close.svg';
import { APIEndpoint} from "../../utils/axios";
import { durationFilterSelect } from "../../utils/configs";
import useAccountDomain from '../../utils/useAccountDomain';
import zoom from '../../assets/icons/zoom.svg';
import DownloadVector from '../../assets/icons/svg/download-vector.svg';
import ReloadVector from '../../assets/icons/svg/reload-vector.svg';
import { CiCalendarDate } from "react-icons/ci";
import { Loading } from '../../common';

export const ListViewGridComponent = (props) => {
  const {
    filtersList, filtersRaw, warehouseArr, setFilteredWidgetData, id,
    isLoading, setLoadingWidgets, customDateLabel, setCustomDateLabel,
    setShowDateModal, setWidgetRangeId
  } = props;

  const { t } = useTranslation();
  let inputRef = useRef();
  const [rowsData, setRowData] = useState([]);
  const [searchSlidebar, setSearchSlidebar] = useState(false);
  const [gridAPI, setGridAPI] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(null);
  const [selWarehouse, setSelWarehouse] = useState([]);
  const [filters, setFilters] = useState("");
  const [filterType, setFilterType] = useState('none');
  const domainNGo = useAccountDomain();

const detectFilterType = (raw) => {
  if (!raw) return 'none';
  const keys = Object.keys(raw);
  const applied = raw.appliedFilters ?? raw;

  if (keys.includes('warehouseId') || applied?.warehouseId) return 'warehouse';
  if (keys.includes('baseId')) return 'base';
  if (keys.includes('sortBy')) return 'sortBy';
  if (
    applied?.startDate ||
    applied?.endDate ||
    keys.includes('startDate') ||
    keys.includes('endDate')
  ) return 'dateRange';
  return 'none';
};


  useEffect(() => {
    if (
      props.title === 'Physical Quantity of Products Sale Warehouse Wise' &&
      process.env.REACT_APP_ACCOUNT_DOMAIN === domainNGo
    ) {
      const rowsPqty = (Array.isArray(props.rowsData) ? props.rowsData : []).map((row) => ({
        itemName: row.itemName,
        unit: row.unit,
        itemCode: row.itemCode,
        quantity: row.quantity,
      }));
      setRowData(rowsPqty);
    } else {
      const withObjectRemoved = (Array.isArray(props.rowsData) ? props.rowsData : []).map((item) => {
        const newItem = { ...item };
        if (newItem?.product && typeof newItem.product === 'object') {
          newItem.product = newItem.product.name ?? "";
        }
        return newItem;
      });
      setRowData(withObjectRemoved);
    }

    if (filtersList[0]) {
      setSelWarehouse(filtersList[0]);
    }
  }, [props.rowsData]);

  useEffect(() => {
    if (filtersRaw) {
      setFilterType(detectFilterType(filtersRaw));
      const hasAppliedDates =
        filtersRaw?.appliedFilters?.startDate &&
        filtersRaw?.appliedFilters?.endDate;

      if (hasAppliedDates) {
        setFilters('betweenDates');
        const s = new Date(filtersRaw.appliedFilters.startDate).toLocaleDateString("en-GB", { day: '2-digit', month: 'short' });
        const e = new Date(filtersRaw.appliedFilters.endDate).toLocaleDateString("en-GB", { day: '2-digit', month: 'short' });
        setCustomDateLabel((prev) => ({ ...prev, [id]: `${s} → ${e}` }));
      } else if (filtersRaw.sortBy && !filters) {
        setFilters(filtersRaw.sortBy);
      }
    }
  }, [filtersRaw]);

  // Note: filter changes are handled by changeFilter() to avoid duplicate API requests.

  useEffect(() => {
    if (filterType === 'warehouse') {
      setWarehouseOptions();
    }
  }, [t, warehouseArr, filterType]);

  useEffect(() => {
    if (searchSlidebar) {
      inputRef.current?.focus();
    }
  }, [searchSlidebar]);

 React.useEffect(() => {
    if (filtersList[2]) {
      setWarehouseId(filtersList[2].id);
    }
    if (filtersList[0] && selWarehouse !== '') {
      setSelWarehouse(filtersList[0]);
    }
    if (!filters && filtersList[1]) {      
      setFilters(filtersList[1]);
    }
  }, [filtersList]);


  const preCompile = {
    warehouse: t('selectButtons.selWarehouse'),
  };

  const setWarehouseOptions = async () => {
    const options = [{ key: 0, label: preCompile.warehouse, value: '' }];
    warehouseArr.filter((fieldValue, index) => {
      options.push({ key: index + 1, label: `${fieldValue.value}`, value: `${fieldValue.value}` });
      return fieldValue;
    });
    setWarehouses(options);
  };


  const onReadyHandler = (params) => {
    setGridAPI(params.api);
  };

  const onColumnResizedHandler = () => {};

  const rowClass = "tableRowClass";
  const getRowClass = (params) => {
    if (params.node.rowIndex % 2 === 0) return 'tableRowClass';
  };


  const buildSortByUrl = (widgetId, sortByValue, raw) => {
    const applied = raw?.appliedFilters ?? raw;

    if (
      sortByValue === 'betweenDates' &&
      applied?.startDate &&
      applied?.endDate
    ) {
      return `portal/v1/widget/${widgetId}?sortBy=betweenDates&startDate=${applied.startDate}&endDate=${applied.endDate}`;
    }
    return `portal/v1/widget/${widgetId}?sortBy=${sortByValue}`;
  };

  const reloadGridData = async () => {
    if (!gridAPI) return;
    if (filterType === 'none' || filterType === 'base') return;
    if (warehouseId) {
      gridAPI.showLoadingOverlay();
      try {
        const resp = await APIEndpoint.get(`portal/v1/widget/${id}?warehouseId=${warehouseId}`);
        if (resp.success) {
          setFilteredWidgetData(resp.data);
          if (resp.data) gridAPI.hideOverlay();
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (filters) {
      try {
        gridAPI.showLoadingOverlay();
        const url = buildSortByUrl(id, filters, filtersRaw);
        const resp = await APIEndpoint.get(url);
        if (resp.success) {
          setFilteredWidgetData(resp.data);
          if (resp.data) gridAPI.hideOverlay();
        }
      } catch (error) {
       
      }
    }
  };

  const changeFilter = async (e) => {
    e.preventDefault();
    const value = e.target.value;
    const wId = id;

    if (value !== 'betweenDates') {
      setCustomDateLabel((prev) => ({ ...prev, [wId]: "" }));
    }
    if (value === "betweenDates") {
      setShowDateModal(true);
      setWidgetRangeId(wId);
      return;
    }

    setFilters(value);
    setLoadingWidgets((prev) => ({ ...prev, [wId]: true }));
    try {
      const resp = await APIEndpoint.get(`portal/v1/widget/${wId}?sortBy=${value}`);
      if (resp.success) {
        setFilteredWidgetData(resp.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingWidgets((prev) => ({ ...prev, [wId]: false }));
    }
  };

  const onItemTypeChange = async (e) => {
    gridAPI.showLoadingOverlay();
    setSelWarehouse(e.target.value);
    const wName = warehouseArr.find((w) => w.value === e.target.value);
    if (wName) {
      setWarehouseId(wName.id);
      try {
        const resp = await APIEndpoint.get(`portal/v1/widget/${id}?warehouseId=${wName.id}`);
        if (resp.success) {
          setFilteredWidgetData(resp.data);
          if (props.rowsData.length) gridAPI.hideOverlay();
        }
      } catch (error) {
        gridAPI.showNoRowsOverlay();
        console.log(error);
      }
    } else {
      setWarehouseId(null);
      gridAPI.showNoRowsOverlay();
      setFilteredWidgetData([]);
      setRowData([]);
    }
  };


  const getFileName = () => `${props.title}.csv`;

  const onBtExport = () => {
    gridAPI.exportDataAsCsv({ fileName: getFileName() });
  };

  const onSearchClick = () => {
    setSearchSlidebar(!searchSlidebar);
  };

  const onFilterTextBoxChanged = (filterId) => {
    gridAPI.setQuickFilter(
      document.getElementById('filter-text-box-' + filterId).value
    );
  };

  return (
    <>
      <div className="cmpHeadingBlock flexRow alignItemsCenter justifyContentSpaceBetween">
        <div style={{ whiteSpace: 'nowrap' }} className='mb-2 component-header-space cmpHeading'>
          {props.title || ''}
        </div>

        <div className="cmpHeadingRight flexRow alignItemsCenter justifyContentFlexEnd">
          <>
            {!searchSlidebar
              ? <img className="icon-size" src={SearchVector} alt="Search icon" onClick={onSearchClick} />
              : <img className="icon-size" src={CloseSearch} alt="Search icon" onClick={onSearchClick} />
            }
            {searchSlidebar && (
              <input
                className='filter-text-box'
                ref={inputRef}
                id={`filter-text-box-${props.id}`}
                type="search"
                placeholder={t('filters.searchText')}
                onInput={() => onFilterTextBoxChanged(props.id)}
              />
            )}

            <img className="icon-divider" src={VerticalDivider} alt="|" />
            <img className="icon-size" src={DownloadVector} alt="Download icon" onClick={onBtExport} />
            <img className="icon-size" src={ReloadVector} alt="Reload icon" onClick={reloadGridData} />
          </>

          {filterType === 'sortBy' && (
            <>
              <img className="icon-divider" src={VerticalDivider} alt="|" />
                <span className='flexRow justifyContentSpaceBetween alignItemsCenter'>
                  {(filters === "betweenDates" || filtersRaw?.appliedFilters?.startDate) && (
                  <span
                  onClick={() => { setShowDateModal(true); setWidgetRangeId(id); }}
                  title={
                  filtersRaw?.appliedFilters?.startDate
                  ? `Active: ${new Date(filtersRaw.appliedFilters.startDate).toLocaleDateString("en-GB", { day: '2-digit', month: 'short' })} → ${new Date(filtersRaw.appliedFilters.endDate).toLocaleDateString("en-GB", { day: '2-digit', month: 'short' })}`
                  : "Edit date range"
                  }
                  >
                  <CiCalendarDate size={20} color={'#e8812eff'} style={{ cursor: 'pointer' }} />
                  &nbsp;&nbsp;
                  </span>
                  )}
                <button className='dashboard-border select-dashboard-border margBottom00'>
                  <select
                    className='dashboard-button-report'
                    title={(filters === "betweenDates" && customDateLabel) ? customDateLabel : ""}
                    onChange={changeFilter}
                    value={filters || ""}
                  >
                    {durationFilterSelect.map((item, index) => {
                      let label = item.label;
                      if (item.value === "betweenDates" && customDateLabel) {
                        label = customDateLabel;
                      }
                      return <option key={index} value={item.value}>{label}</option>;
                    })}
                  </select>
                </button>
              </span>
            </>
          )}

          {filterType === 'warehouse' && (
            <>
              <img className="icon-divider" src={VerticalDivider} alt="|" />
               <button className='dashboard-border select-dashboard-border margBottom00'>
                <select
                  className='dashboard-button-report'
                  onChange={onItemTypeChange}
                  value={selWarehouse}
                  title={warehouses.find(w => w.value === selWarehouse)?.label || ""}
                >
                  {warehouses.map((item, index) => (
                    <option key={index} value={item.value}>{item.label}</option>
                  ))}
                </select>
              </button>
            </>
          )}

          {filterType === 'dateRange' && (
            <>
              <img className="icon-divider" src={VerticalDivider} alt="|" />
              <span className='flexRow justifyContentSpaceBetween alignItemsCenter'>
                <span
                  onClick={() => { setShowDateModal(true); setWidgetRangeId(id); }}
                  title="Select date range"
                >
                  <CiCalendarDate size={20} color={'#e8812eff'} style={{ cursor: 'pointer' }} />
                  &nbsp;&nbsp;
                </span>
                {filtersRaw?.sortBy && (
                  <button className='dashboard-border select-dashboard-border margBottom00'>
                    <select
                      className='dashboard-button-report'
                      title={customDateLabel || ""}
                      onChange={changeFilter}
                      value={filters || ""}
                    >
                      {durationFilterSelect.map((item, index) => {
                        let label = item.label;
                        if (item.value === "betweenDates" && customDateLabel) {
                          label = customDateLabel;
                        }
                        return <option key={index} value={item.value}>{label}</option>;
                      })}
                    </select>
                  </button>
                )}
              </span>
            </>
          )}

        </div>
      </div>

      {isLoading ? (
        <div
          className='flexRow justifyContentCenter alignItemsCenter'
          style={{ height: '250px' }}
        >
          <Loading />
        </div>
      ) : (
        <div
          id="myGrid"
          className="ag-theme-alpine-dark grid-container-dashboard"
          style={{
            minWidth: "600px",
            padding: '0px',
            maxWidth: 'calc(100% - 3px)',
            height: "250px",
            marginBottom: '1rem',
          }}
        >
          <AgGridReact
            reactNext={true}
            domLayout="autoWidth"
            headerHeight={36}
            columnDefs={
              props?.columnDefs && Array.isArray(props.columnDefs)
                ? props.columnDefs
                    .filter((item) => item.field && item.headerName)
                    .map((item) => {
                      if (
                        (item.field === 'name' && item.headerName === 'Name') ||
                        (item.field === 'code' && item.headerName === 'Code')
                      ) {
                        return { ...item, maxWidth: 130, minWidth: 100 };
                      }
                      return item;
                    })
                : []
            }
            rowModelType="clientSide"
            rowData={rowsData}
            onGridReady={onReadyHandler}
            onColumnResized={onColumnResizedHandler}
            rowClass={rowClass}
            getRowClass={getRowClass}
            suppressRowClickSelection={true}
            rowDragManaged={false}
            singleClickEdit={false}
            editType={''}
            animateRows
            componentWrappingElement={'span'}
            rowDataChangeDetectionStrategy="DeepValueCheck"
            showToolPanel={true}
            overlayLoadingTemplate={
              `<span className="ag-overlay-loading-center">${t('pages.dashboardContent.dashboard.message.wait')}</span>`
            }
            isScrolling={() => { console.log('scrolling...'); return false; }}
            cacheQuickFilter={false}
            sortingOrder={'desc'}
            accentedSort={false}
            excludeChildrenWhenTreeDataFiltering={false}
            alwaysShowHorizontalScroll={false}
            suppressColumnVirtualisation={true}
            suppressHorizontalScroll={true}
          />
          <span className="icon-enlarge-list">
            <img
              alt='zoom'
              src={zoom}
              onClick={() => props.handleZoom(props.chartLabel, props, props.options)}
            />
          </span>
        </div>
      )}
    </>
  );
}